import ListMail from "./ListMail";


const SentMail = () => {
    const urlParam = []
    urlParam['direction'] = 'sent'

    return (
        <ListMail
            urlParam={urlParam}
            pageTitle={'mailbox.sent.list.title'}
        />
    )
}


export default SentMail